var React = require('react');
var $ = require('jquery');
var toastr = require('toastr');
var AuthInfo = require('../../helpers/AuthInfo');

var Tabs = require('react-bootstrap/lib/Tabs');
var Tab = require('react-bootstrap/lib/Tab');
var Form = require('react-bootstrap/lib/Form');
var FormControl = require('react-bootstrap/lib/FormControl');
var FormGroup = require('react-bootstrap/lib/FormGroup');
var Button = require('react-bootstrap/lib/Button');
var Collapse = require('react-bootstrap/lib/Collapse');
var BadgeAddress = require('./BadgeAddress');
var PackageType = require('./PackageType');
var RadioGroup = require('../RadioGroup/RadioGroup');
var Toggle = require('../Toggle/Toggle');
var AddressLabel = require('./AddressLabel');
var PriceFormatter = require('../Formatters/PriceFormatter');
var Modal = require('react-bootstrap/lib/Modal');
var Well = require('react-bootstrap/lib/Well');
var NavLink = require('../NavLink');
var Apoint = false;
var Bpoint = false;
var Cpoint = false;
var Dpoint = false;
var existsNumber = false;
var Select = require('react-bootstrap/lib/SplitButton');
var Option = require('react-bootstrap/lib/MenuItem');

var ControlLabel = require('react-bootstrap/lib/ControlLabel');
var Dropzone = require('react-dropzone');

var w = window;
var d = document;

require('./OrderBox.css');
require('./Home.css');

var style = {
	container: {
		marginTop: 50,
	},

	mapWrapper: {
		position: 'absolute',
		marginLeft: 360,
		width: '100%',
		height: '100%'
	},

	orderBox: {
		width: 360,
		height: '100%',
		backgroundColor: '#fff',
		position: 'absolute',
		top: 50,
		left: 0,
		boxShadow: '1px 0px 10px rgba(0, 0, 0, .05)',
		zIndex: 1
	},

	nextButton: {
		color: '#fff',
		marginTop: '15px',
		backgroundColor: '#03a6dc',
		borderColor: '#03a6dc'		
	},

	backButton: {
		color: '#fff',
		marginTop: '15px',
		backgroundColor: '#748297',
		borderColor: '#748297'
	},

	packageType: {
		display: 'flex', 
		justifyContent: 'space-around', 
		padding: '20px 10px'
	},

	returnToOrigin: {
		padding: '20px 0px'
	},

	addWaypoint: {
		padding: '20px 0px'
	},

	divider: {
		width: '100%', 
		height: '1px', 
		backgroundColor: '#ccc',
		margin: '10px 0px'
	},

	showWaypointAddress: {
		display: 'block'
	},

	hideWaypointAddress: {
		display: 'none'
	},

	addressBox: {
		display: 'flex',
		flexDirection: 'column'
	},

	addressBoxItem: {
		display: 'flex',
		padding: '0px 20px',
		alignItems: 'center',
		justifyContent: 'space-around'
	},

	addressBoxAddresses: {
		display: 'flex',
		flexDirection: 'column',
		flex: '1 1 85%'
	},


	containerLogin: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		height: '100%',
		width: '100%',
		position: 'absolute',
		backgroundColor: '#fff'
	},

	form: {
		width: 300
	},

	containerSignup: {
		display: 'flex',
		justifyContent: 'center',
		flexDirection: 'column',
		alignItems: 'center',
		height: '100%',
		margin: '0 25%'
	}
};

var Home = React.createClass({

	getInitialState: function() {
		return {
			timestamp: Date.now(),
			name: null,
			email: null,
			phone: null,
			cpf: null,
			cnpj: null,
			address: null,
			city: null,
			state: null,
			nickname: null,
			pass: null,
			fgtype: 0,
			deliveryType: 0,
			paymentDay: 5,
			documentFile: null,
			isOpen: 1,
			orderValue: 0,


			origin: '',
			originNumber: '',
			originComplement: '',
			originWhatTodo: '',
			originStreet: '',
			originVCode: '',

			destination: '',
			destinationNumber: '',
			destinationComplement: '',
			destinationWhatTodo: '',
			destinationStreet: '',
			destinationVCode: '',

			waypoint01: '',
			waypoint01Number: '',
			waypoint01Complement: '',
			waypoint01WhatTodo: '',
			waypoint01Street: '',
			
			waypoint02: '',
			waypoint02Number: '',
			waypoint02Complement: '',
			waypoint02WhatTodo: '',
			waypoint02Street: '',
			
			returnToOrigin: false,
			packageOptions: [
				{
					label: 'Envelope',
					name: '0',
					checked: true
				},
				{
					label: '20x20 cm',
					name: '1'
				},
				{
					label: '40x40 cm',
					name: '2'
				}
			],

			paymentTypes: [
				{
					label: 'Visa',
					name: 'visa',
					checked: true
				},
				{
					label: 'Master',
					name: 'master'
				}
			],

			open: {
				destination: true,
				waypoint01: false,
				waypoint02: false
			},

			value: 0,
			distance: {
				text: '',
				value: 0
			},

			duration: {
				text: '',
				value: 0
			},

			showModal: this.getQueryParams(document.location.search, "login") == 1,
			showAlertModal: false,
			showSignupModal: this.getQueryParams(document.location.search, "signup") == 1,
			showPaymentModal: false,

			packageType: '',
			totalDistance: '',

			securityCode: ''
		};
	},

	clearForm: function() {
		return this.setState({ 
			timestamp: Date.now(), 
			name: null,
			email: null,
			phone: null,
			cpf: null,
			cnpj: null,
			address: null,
			city: null,
			state: null,
			nickname: null,
			pass: null,
			paymentDay: 5,
			documentFile: null
		});
	},

	getQueryParams: function(qs, param) {
	    qs = qs.split('+').join(' ');

	    var params = {},
	        tokens,
	        re = /[?&]?([^=]+)=([^&]*)/g;

	    while (tokens = re.exec(qs)) {
	        params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
	    }

	    return params[param];
	},

	componentWillMount: function() {
		this.props.load();

		if(d.getElementById('custom-login')) {
			d.getElementById('custom-login').removeEventListener('click', this.openModal);
		}
		if(d.getElementById('custom-signup')) {
			d.getElementById('custom-signup').removeEventListener('click', this.showSignupModal);
		}
	},

	componentWillUnmount: function() {
		this.props.unload();
	},

	componentDidMount: function() {
    	var me = this, google = w.google;

    	w.GMap = new google.maps.Map(d.getElementById('map'), {
			center: {lat: -23.5652911, lng: -46.6498139},
			zoom: 15,
			mapTypeId: google.maps.MapTypeId.ROADMAP
		});

		me.initListeners();

		if(d.getElementById('custom-login')) {
			d.getElementById('custom-login').addEventListener('click', this.openModal);
		}
		if(d.getElementById('custom-signup')) {
			d.getElementById('custom-signup').addEventListener('click', this.showSignupModal);
		}
	},

	initListeners: function() {
		var me = this,
			google = w.google,
			map = w.GMap,
			autoCmps = d.querySelectorAll('.autocomplete'),
			gService = new google.maps.DirectionsService(),
			gDisplay = new google.maps.DirectionsRenderer(),
			travelMode = google.maps.TravelMode.DRIVING; //ALTERAR

		gDisplay.setMap(map);

		autoCmps.forEach((component) => {
			var el = new google.maps.places.Autocomplete(component);
		
			el.bindTo('bounds', map);
		
			el.addListener('place_changed', () => {
				var place = el.getPlace(), geo, street;

				if (!place.geometry) 
					return;
				
				if(me.isOpen === 0) {
					document.getElementById(component.id).value = "";
					alert('Infelizmente não atendemos nesse horário.');
					return;
				}

				/*var supportedCity = false;
				if(d.querySelector('.initOrder.activebox')) {
					var citys = ["São Paulo", "Osasco", "Carapicuíba", "Barueri", "Cotia", "Guarulhos", "São Caetano do Sul", "São Bernardo do Campo", "Alphaville", "Taboão da Serra", "Santo André"];
					for (var index in citys) {
						if(place.formatted_address.toUpperCase().indexOf(citys[index].toUpperCase()) >= 0) {
							supportedCity = true;
							break;
						}
					}
				} else {
					supportedCity = (place.formatted_address.toUpperCase().indexOf(' - SP'.toUpperCase()) >= 0) || (place.formatted_address.toUpperCase().indexOf(' SP,'.toUpperCase()) >= 0);
				}

				if(!supportedCity) {
					document.getElementById(component.id).value = "";
					alert('Infelizmente ainda não temos cobertura nessa região.');
					return;
				}*/

				if(d.querySelector('.initOrder.activebox')) {
					Apoint = true;
				} else {
					Bpoint = true;
				}

				street = place.formatted_address;
				var number = "";
				if (street.match(/\d/g) == null) {
					existsNumber = false;
					street = street.substring(0, street.indexOf(',')) + ", ";
					if(street.indexOf(' - ') > 0) {
						street = street.substring(0, street.indexOf(' - ')) + ", ";
					}

					var input = document.getElementById(component.id);
					input.value = street + "número";
					input.focus();
					input.setSelectionRange(street.length, street.length+6);
				} else {
					existsNumber = true;
				}

				geo = place.geometry;

				if (geo.viewport) {
					map.fitBounds(geo.viewport);
				} else {
					map.setCenter(geo.location);
					map.setZoom(17);
				}

				me.setState({
					[component.id]: geo.location.toJSON(),
					[component.id + 'Street']: street
				})

				me.setRoute(me.getDataToRoute(gService, gDisplay, travelMode), this.state.returnToOrigin);
			});
		})
	},

	getDataToRoute: function(service, display, travelMode, tripReturn = false) {
		var me = this, state = me.state, waypoints = [];
		var dest = state.destination;

		if (state.waypoint01) {
			waypoints.push({
				location: dest,
				stopover: true
			});
			dest = state.waypoint01;
		};

		if (state.waypoint02) {
			waypoints.push({
				location: dest,
				stopover: true
			});
			dest = state.waypoint02;
		}

		if (tripReturn) {
			waypoints.push({
				location: dest,
				stopover: true
			});
			dest = state.origin;
		}

		return {
			service: service,
			display: display,
			travelMode: travelMode,
			origin: state.origin,
			destination: dest,
			waypoints: waypoints
		}
	},

	setRoute: function(data, returnToOrigin) {
		var me = this;

		if (!data.origin || !data.destination)
			return;

		var lats = [data.origin.lat, 0, 0, 0];
		var lons = [data.origin.lng, 0, 0, 0];
		var returnOrigin = returnToOrigin ? 1 : 0;
		var deliveryType = me.state.deliveryType;

		var idx = 1;
		for(const index in data.waypoints) {
			lats[idx] = data.waypoints[index].location.lat;
			lons[idx] = data.waypoints[index].location.lng;
			idx++;
		}
		
		if(!returnToOrigin && idx < 4) {
			lats[idx] = data.destination.lat;
			lons[idx] = data.destination.lng;
		}

		fetch('https://us-central1-ajato-29abc.cloudfunctions.net/estimated_order?email=EstimatedForApp&password=EstimatedForApp&lat0='+lats[0]+'&lon0='+lons[0]+'&lat1='+lats[1]+'&lon1='+lons[1]+'&lat2='+lats[2]+'&lon2='+lons[2]+'&lat3='+lats[3]+'&lon3='+lons[3]+'&return='+returnOrigin+'&delivery='+deliveryType)
		.then(function(response) {
			return response.json();
		}).then(function(result) {
			if(result && result.error == false && result.totalValue >= 0 && result.totalDistance >= 0 && result.estimatedTime >= 0) {
				me.setState({
					distance: {text: (result.totalDistance / 1000).toFixed(1) + " Km", value: result.totalDistance},
					duration: {text: "", value: result.estimatedTime},
					orderValue: result.totalValue
				})
			}
		});
		
		data.service.route({
			origin		: data.origin,
			waypoints	: data.waypoints,
			optimizeWaypoints: true,
			destination	: data.destination,
			travelMode	: data.travelMode,
			provideRouteAlternatives: true,
			avoidHighways: true,
			avoidTolls: true
		}, (response, status) => {
			if (status === w.google.maps.DirectionsStatus.OK) {
				
				var shortestIdx = 0;
				var distance = Number.MAX_VALUE;
				var duration = Number.MAX_VALUE;

				response.routes.forEach((route, idx) => {
					var _dist = 0;
					var _dur = 0;
					route.legs.forEach((leg, _id) => {
						_dist += leg.distance.value; 
						_dur += leg.duration.value;
					});
					if (_dist < distance) {
						shortestIdx = idx;
						distance = _dist;
						duration = _dur;
					}
				});

				response.routes = [response.routes[shortestIdx]];
				data.display.setDirections(response);
			
			} else {
				toastr.error('Erro ao calcular a rota informada');
			}
		})
	},

	strToNum: function(str) {
		return +(str.replace(/,/,'.'));
	},

	getKM: function(currentDistance, newDistance) {
		var me = this,
			currentValue = currentDistance.split('km')[0],
			newValue = newDistance.split('km')[0],
			distanceText = (me.strToNum(currentValue) + me.strToNum(newValue)).toString();

		return distanceText.replace('.',',').concat(' km');
	},

	getMeters: function(currentDistance, newDistance) {
		var me = this,
			currentValue = currentDistance.split('m')[0],
			newValue = newDistance.split('m')[0],
			distanceText = (me.strToNum(currentValue) + me.strToNum(newValue)).toString();

		return distanceText.replace('.',',').concat(' m');
	},

	back: function() {
		var closeBox = d.querySelector('.closeOrder.activebox');

		if (closeBox) {
			$('.closeOrder').removeClass('activebox');
			$('.closeOrder').addClass('nextbox');
			$('.initOrder').removeClass('backbox');
			$('.initOrder').addClass('activebox');
		} else {
			$('.payOrder').removeClass('activebox');
			$('.payOrder').addClass('nextbox');
			$('.closeOrder').removeClass('backbox');
			$('.closeOrder').addClass('activebox');
		}
	},

	next: function() {

		let me = this;
		
		if(!existsNumber) {
			toastr.error('Para continuar preencha o número no endereço');
			return;
		}

		existsNumber = false;
		var initBox = d.querySelector('.initOrder.activebox');

		if (initBox) {
			if (!Apoint) {
				return;
			}
			$('.initOrder').removeClass('activebox');
			$('.initOrder').addClass('backbox');
			$('.closeOrder').removeClass('nextbox');
			$('.closeOrder').addClass('activebox');
		} else {
			if (!Apoint || !Bpoint) {
				return;
			}
			$('.closeOrder').removeClass('activebox');
			$('.closeOrder').addClass('backbox');
			$('.payOrder').removeClass('nextbox');
			$('.payOrder').addClass('activebox');
		}
	},

	changeModal: function() {
		//if (!this.props.settings.list.depositEnable && !this.props.auth.boletoPermission)
			//this.payWithMP();
	},

	getAddresses: function() {
		var me = this, state = me.state;

		return (
			<div style={style.addressBox}>
				<div style={style.addressBoxItem}>
					<AddressLabel arriveOrder={0}/>
					<div style={style.addressBoxAddresses} >
						<b>{state.originStreet}</b>
						<span>{state.originComplement + ' - ' + state.originWhatTodo}</span>
					</div>
				</div>
				
				<div style={style.divider} />

				<div style={style.addressBoxItem}>
					<AddressLabel arriveOrder={1}/>
					<div style={style.addressBoxAddresses} >
						<b>{state.destinationStreet}</b>
						<span>{state.destinationComplement + ' - ' + state.destinationWhatTodo}</span>
					</div>
				</div>

				<div style={style.divider} />

				{me.getAddressWay1()}
				{me.getAddressWay2()}
			</div>
		)
	},

	getAddressWay1: function() {
		var me = this, state = me.state;

		if (state.waypoint01) {
			return (
				<div>
					<div style={style.addressBoxItem}>
						<AddressLabel arriveOrder={2}/>
						<div style={style.addressBoxAddresses} >
							<b>{state.waypoint01Street}</b>
							<span>{state.waypoint01Complement + ' - ' + state.waypoint01WhatTodo}</span>
						</div>
					</div>

					<div style={style.divider} />
				</div>
			)
		}
	},

	getAddressWay2: function() {
		var me = this, state = me.state;

		if (state.waypoint02) {
			return (
				<div>
					<div style={style.addressBoxItem}>
						<AddressLabel arriveOrder={3}/>
						<div style={style.addressBoxAddresses} >
							<b>{state.waypoint02Street}</b>
							<span>{state.waypoint02Complement + ' - ' + state.waypoint02WhatTodo}</span>
						</div>
					</div>

					<div style={style.divider} />
				</div>
			)
		}
	},

	onInputChange: function(e) {
	    this.setState({[e.target.name]: e.target.value});
	},

	onInputPaymentChange: function(e) {
		this.setState({[e.target.id]: e.target.value});
	},

	onChangePackage : function(options) {
		this.setState({ packageOptions: options });
	},

	onChangeReturnToOrigin: function() {
		var me = this,
			google = w.google,
			gService = new google.maps.DirectionsService(),
			gDisplay = new google.maps.DirectionsRenderer(),
			travelMode = google.maps.TravelMode.DRIVING;

		me.setRoute(me.getDataToRoute(gService, gDisplay, travelMode, !this.state.returnToOrigin), !this.state.returnToOrigin);

		this.setState({ returnToOrigin: !this.state.returnToOrigin});
	},

	onToggleWaypoint: function() {
		var me = this, {waypoint01, waypoint02} = me.state;

		if (!waypoint01) {
			return this.setState({open: { destination: false, waypoint01: true, waypoint02: false }})
		} else if(!waypoint02) {
			return this.setState({open: { destination: false, waypoint01: false, waypoint02: true }})
		}
	},

	getPackageType: function() {
		var me = this, type = me.state.packageOptions.filter((pack) => { 
			return pack.checked === true 
		});

		return type[0].name;
	},

	openModal() {
		this.setState({showModal: true});
	},

	closeModal() {
		this.setState({showModal: false});
	},

	openAlertModal() {
		this.setState({showAlertModal: true});
	},

	closeAlertModal() {
		this.setState({showAlertModal: false});
		//this.setState({showPaymentModal: true});
	},

	showSignupModal() {
		this.setState({showSignupModal: true});
	},

	closeSignupModal() {
		this.setState({showSignupModal: false});
	},

	openPaymentModal() {
		this.setState({showPaymentModal: true});
	},

	closePaymentModal() {
		this.setState({showPaymentModal: false});
	},

	payOrder: function() {
		var me = this, authed = me.props.auth.authenticated;

		if (!authed)
			return me.openModal();

		me.openPaymentModal();
	},

	payWithDeposit: function() {
		this.otherPayment();
		this.openAlertModal();
	},

	otherPayment: function() {
		var active = d.querySelector('.buttonsbox.activepaybox');

		if (active) {
			d.querySelector('.buttonsbox').classList.remove('activepaybox');
			d.querySelector('.buttonsbox').classList.add('backpaybox');
			d.querySelector('.depositsbox').classList.remove('nextpaybox');
			d.querySelector('.depositsbox').classList.add('activepaybox');
		} else {
			d.querySelector('.depositsbox').classList.remove('activepaybox');
			d.querySelector('.depositsbox').classList.add('nextpaybox');
			d.querySelector('.buttonsbox').classList.remove('backpaybox');
			d.querySelector('.buttonsbox').classList.add('activepaybox');
		}
	},

	payWithMP: function() {
		var active = d.querySelector('.buttonsbox.activepaybox'), MP = w.Mercadopago;

		if (active) {
			d.querySelector('.buttonsbox').classList.remove('activepaybox');
			d.querySelector('.buttonsbox').classList.add('backpaybox');
			d.querySelector('.apibox').classList.remove('nextpaybox');
			d.querySelector('.apibox').classList.add('activepaybox');
		} else {
			d.querySelector('.apibox').classList.remove('activepaybox');
			d.querySelector('.apibox').classList.add('nextpaybox');
			d.querySelector('.buttonsbox').classList.remove('backpaybox');
			d.querySelector('.buttonsbox').classList.add('activepaybox');
		}

		MP.getIdentificationTypes();
	},

	showMessageMP: function() {
		var active = d.querySelector('.apibox.activepaybox')

		if (active) {
			d.querySelector('.apibox').classList.remove('activepaybox');
			d.querySelector('.apibox').classList.add('backpaybox');
			d.querySelector('.messagebox').classList.remove('nextpaybox');
			d.querySelector('.messagebox').classList.add('activepaybox');
		} else {
			d.querySelector('.messagebox').classList.remove('activepaybox');
			d.querySelector('.messagebox').classList.add('nextpaybox');
			d.querySelector('.apibox').classList.remove('backpaybox');
			d.querySelector('.apibox').classList.add('activepaybox');
		}
	},

	showMessageDeposit: function() {
		var active = d.querySelector('.depositsbox.activepaybox')

		if (active) {
			d.querySelector('.depositsbox').classList.remove('activepaybox');
			d.querySelector('.depositsbox').classList.add('backpaybox');
			d.querySelector('.messagebox').classList.remove('nextpaybox');
			d.querySelector('.messagebox').classList.add('activepaybox');
		} else {
			d.querySelector('.messagebox').classList.remove('activepaybox');
			d.querySelector('.messagebox').classList.add('nextpaybox');
			d.querySelector('.depositsbox').classList.remove('backpaybox');
			d.querySelector('.depositsbox').classList.add('activepaybox');
		}
	},

	showMessageBoleto: function() {
		var active = d.querySelector('.depositsbox.activepaybox')

		if (active) {
			d.querySelector('.buttonsbox').classList.remove('activepaybox');
			d.querySelector('.buttonsbox').classList.add('backpaybox');
			d.querySelector('.messagebox').classList.remove('nextpaybox');
			d.querySelector('.messagebox').classList.add('activepaybox');
		} else {
			d.querySelector('.messagebox').classList.remove('activepaybox');
			d.querySelector('.messagebox').classList.add('nextpaybox');
			d.querySelector('.buttonsbox').classList.remove('backpaybox');
			d.querySelector('.buttonsbox').classList.add('activepaybox');
		}
	},

	random: function() {
		return Math.random().toString(36).slice(-10);
	},

	vCode: function() {
		var random = (this.random() + this.random()).slice(4, 8),
			upper  = random[Math.floor(Math.random() * 3)].toUpperCase();

		var randomCode = random.slice(0, 3).concat(upper);
		return randomCode.toLowerCase();
	},

	createOrder: function(data) {
		this.props.createOrder(data)
	},

	createOrderRequest: function(data) {
		this.props.createOrderRequest(data);
	},

	requestPaymentWithMP: function() {
		var me = this, MP = w.Mercadopago, form = d.querySelector('#paymentform');

		if (!MP)
			return toastr.error('Ocorreu um erro ao processar a solicitação');

		MP.createToken(form, me.closePaymentWithMP);
	},

	closePaymentWithMP: function(status, response) {
		var me = this;

		if (status === 200) {
			var cardType = me.state.paymentTypes.filter((cardtype) => {
					return cardtype.checked === true;
				}),
				packageType = me.state.packageOptions.filter((pack) => { 
					return pack.checked === true 
				}),
				data = {
					status: 0,
					userId: me.props.auth.id,
					userEmail: AuthInfo.getUserEmail(),
					createdAt: new Date().getTime(),
					estimatedTime: me.state.duration.value,
					origin: me.state.origin,
					originStreet: me.state.originStreet,
					originNumber: me.state.originNumber,
					deliveryType: me.state.deliveryType,
					originComplement: me.state.originComplement,
					originWhatTodo: me.state.originWhatTodo,
					originVCode: me.vCode(),
					destination: me.state.destination,
					destinationStreet: me.state.destinationStreet,
					destinationNumber: me.state.destinationNumber,
					destinationComplement: me.state.destinationComplement,
					destinationWhatTodo: me.state.destinationWhatTodo,
					destinationVCode: me.vCode(),
					waypoint01: me.state.waypoint01,
					waypoint01Street: me.state.waypoint01Street,
					waypoint01Number: me.state.waypoint01Number,
					waypoint01Complement: me.state.waypoint01Complement,
					waypoint01WhatTodo: me.state.waypoint01WhatTodo,
					waypoint01VCode: me.vCode(),
					waypoint02: me.state.waypoint02,
					waypoint02Street: me.state.waypoint02Street,
					waypoint02Number: me.state.waypoint02Number,
					waypoint02Complement: me.state.waypoint02Complement,
					waypoint02WhatTodo: me.state.waypoint02WhatTodo,
					waypoint02VCode: me.vCode(),
					returnToOrigin: me.state.returnToOrigin,
					paymentMethod: 1,
					totalDistance: me.state.distance.value,
					packageType: packageType[0].name,
					token: response.id,
					value: me.state.orderValue,
					payment_method_id: cardType[0].name
				};;

			me.createOrderRequest(data);

			me.showMessageMP();
			//me.closePaymentModal();
		} else {
			toastr.error("Pagamento não autorizado, por favor confira seus dados.")
		}
	},

	closePaymentWithDeposit: function() {
		var me = this, packageType = me.state.packageOptions.filter((pack) => { 
				return pack.checked === true 
			}), data = {
				userId: me.props.auth.id,
				createdAt: new Date().getTime(),
				estimatedTime: me.state.duration.value,
				status: 0,
				origin: me.state.origin,
				originStreet: me.state.originStreet,
				originNumber: me.state.originNumber,
				deliveryType: me.state.deliveryType,
				originComplement: me.state.originComplement,
				originWhatTodo: me.state.originWhatTodo,
				originVCode: me.vCode(),
				destination: me.state.destination,
				destinationStreet: me.state.destinationStreet,
				destinationNumber: me.state.destinationNumber,
				destinationComplement: me.state.destinationComplement,
				destinationWhatTodo: me.state.destinationWhatTodo,
				destinationVCode: me.vCode(),
				waypoint01: me.state.waypoint01,
				waypoint01Street: me.state.waypoint01Street,
				waypoint01Number: me.state.waypoint01Number,
				waypoint01Complement: me.state.waypoint01Complement,
				waypoint01WhatTodo: me.state.waypoint01WhatTodo,
				waypoint01VCode: me.vCode(),
				waypoint02: me.state.waypoint02,
				waypoint02Street: me.state.waypoint02Street,
				waypoint02Number: me.state.waypoint02Number,
				waypoint02Complement: me.state.waypoint02Complement,
				waypoint02WhatTodo: me.state.waypoint02WhatTodo,
				waypoint02VCode: me.vCode(),
				returnToOrigin: me.state.returnToOrigin,
				paymentMethod: 0,
				totalDistance: me.state.distance.value,
				packageType: packageType[0].name,
				value: me.state.orderValue
			};

		me.createOrder(data);
		me.showMessageDeposit();
	},

	closePaymentWithBoleto: function() {
		var me = this, packageType = me.state.packageOptions.filter((pack) => { 
				return pack.checked === true 
			}), data = {
				userId: me.props.auth.id,
				createdAt: new Date().getTime(),
				estimatedTime: me.state.duration.value,
				status: 1,
				origin: me.state.origin,
				originStreet: me.state.originStreet,
				originNumber: me.state.originNumber,
				deliveryType: me.state.deliveryType,
				originComplement: me.state.originComplement,
				originWhatTodo: me.state.originWhatTodo,
				originVCode: me.vCode(),
				destination: me.state.destination,
				destinationStreet: me.state.destinationStreet,
				destinationNumber: me.state.destinationNumber,
				destinationComplement: me.state.destinationComplement,
				destinationWhatTodo: me.state.destinationWhatTodo,
				destinationVCode: me.vCode(),
				waypoint01: me.state.waypoint01,
				waypoint01Street: me.state.waypoint01Street,
				waypoint01Number: me.state.waypoint01Number,
				waypoint01Complement: me.state.waypoint01Complement,
				waypoint01WhatTodo: me.state.waypoint01WhatTodo,
				waypoint01VCode: me.vCode(),
				waypoint02: me.state.waypoint02,
				waypoint02Street: me.state.waypoint02Street,
				waypoint02Number: me.state.waypoint02Number,
				waypoint02Complement: me.state.waypoint02Complement,
				waypoint02WhatTodo: me.state.waypoint02WhatTodo,
				waypoint02VCode: me.vCode(),
				returnToOrigin: me.state.returnToOrigin,
				paymentMethod: 2,
				totalDistance: me.state.distance.value,
				packageType: packageType[0].name,
				value: me.state.orderValue
			};

		me.createOrder(data);
		me.otherPayment();
		me.showMessageDeposit();
	},

	closePaymentWithMoney: function() {
		var me = this, packageType = me.state.packageOptions.filter((pack) => { 
				return pack.checked === true 
			}), data = {
				userId: me.props.auth.id,
				createdAt: new Date().getTime(),
				estimatedTime: me.state.duration.value,
				status: 1,
				origin: me.state.origin,
				originStreet: me.state.originStreet,
				originNumber: me.state.originNumber,
				deliveryType: me.state.deliveryType,
				originComplement: me.state.originComplement,
				originWhatTodo: me.state.originWhatTodo,
				originVCode: me.vCode(),
				destination: me.state.destination,
				destinationStreet: me.state.destinationStreet,
				destinationNumber: me.state.destinationNumber,
				destinationComplement: me.state.destinationComplement,
				destinationWhatTodo: me.state.destinationWhatTodo,
				destinationVCode: me.vCode(),
				waypoint01: me.state.waypoint01,
				waypoint01Street: me.state.waypoint01Street,
				waypoint01Number: me.state.waypoint01Number,
				waypoint01Complement: me.state.waypoint01Complement,
				waypoint01WhatTodo: me.state.waypoint01WhatTodo,
				waypoint01VCode: me.vCode(),
				waypoint02: me.state.waypoint02,
				waypoint02Street: me.state.waypoint02Street,
				waypoint02Number: me.state.waypoint02Number,
				waypoint02Complement: me.state.waypoint02Complement,
				waypoint02WhatTodo: me.state.waypoint02WhatTodo,
				waypoint02VCode: me.vCode(),
				returnToOrigin: me.state.returnToOrigin,
				paymentMethod: 3,
				totalDistance: me.state.distance.value,
				packageType: packageType[0].name,
				value: me.state.orderValue
			};

		me.createOrder(data);
		me.otherPayment();
		me.showMessageDeposit();
	},

	onChangePaymentType: function(options) {
		this.setState({ paymentTypes: options });	
	},

	signIn: function(email, pass) {
		this.props.signIn(email, pass);
	},

	forgot: function(email) {
		this.props.forgot(email);
	},

	onSubmit (e) {
	    var me = this, { email, pass } = this.state;

	    e.preventDefault();

	    me.signIn({email: email, pass: pass});
	    me.closeModal();
	},

	forgotPass (e) {
	    var me = this, { email } = this.state;

	    if(email == "") {
	    	toastr.error('Por favor preencha o e-mail!');
	    } else {
	    	me.forgot({email: email});
	    	me.closeModal();
	    }
	},

	register (e) {
	    this.closeModal()
	    this.showSignupModal()
	},

	signUp: function(userData) {
		this.props.signUp(userData);
	},

	onSubmitSignupPJ (e) {
		var me = this, state = me.state;
		if(state.name === "" || state.email === "" || state.phone === "" || state.pass === "" || state.cnpj === "" || state.address === "" || state.city === "" || state.state === "" || state.nickname === "" || state.name === null || state.email === null || state.phone === null || state.pass === null || state.cnpj === null || state.address === null || state.city === null || state.state === null || state.nickname === null) {
			toastr.error('Por favor preencha todos os dados');
			return;
		}
		if(state.documentFile === "undefined" || state.documentFile === null) {
			toastr.error('Por favor faça o upload do arquivo');
			return;
		}
		this.onSubmitSignup(e);
	},

	onSubmitSignupPF (e) {
		var me = this, state = me.state;
		if(state.name === "" || state.email === "" || state.phone === "" || state.pass === "" || state.cpf === "" || state.name === null || state.email === null || state.phone === null || state.pass === null || state.cpf === null) {
			toastr.error('Por favor preencha todos os dados');
			return;
		}
		this.onSubmitSignup(e);
	},

	onSubmitSignup (e) {
	    var me = this, state = me.state,
	    	data = {
	    		name: state.name,
	    		email: state.email,
	    		phone: state.phone,
	    		pass: state.pass,
	    		fgtype: state.fgtype,
	    		cpf: state.cpf,
	    		cnpj: state.cnpj,
	    		address: state.address,
				city: state.city,
				state: state.state,
				nickname: state.nickname,
				paymentDay: state.paymentDay,
				documentFile: state.documentFile
	    	};

	    e.preventDefault();

	    me.signUp(data);

	    me.clearForm();
	    me.closeSignupModal();
	},

	handleType: function(type) {
		var me = this;

		this.setState({ fgtype: type });
	},

	boletoButton: function() {
		var me = this;

		if(me.props.auth.boletoPermission) {
			return (
				<Button onClick={me.closePaymentWithBoleto}
						block
						bsStyle="primary"
						style={{width: '50%', backgroundColor: '#03a6dc', borderColor: '#03a6dc', color: '#fff'}}>
						{"Boleto pós pago"}
				</Button>
			)
		}
	},

	transferButton: function() {
		var me = this;

		if(me.props.settings.list.depositEnable) {
			return (
				<Button onClick={me.payWithDeposit}
						block
						bsStyle="primary"
						style={{width: '50%', backgroundColor: '#03a6dc', borderColor: '#03a6dc', color: '#fff'}}>
						{"Tranferência"}
				</Button>
			)
		}
	},

	getForm: function(fgType) {
		var me = this;

		if (fgType === 0) {
			return (
				<Form id="formSignupPF" onChange={me.onInputChange} key={me.state.timestamp}>
					<FormGroup  controlId="formName">
						<ControlLabel>Nome</ControlLabel>
						<FormControl name="name" type="text" placeholder="Nome"/>
					</FormGroup>

					<FormGroup  controlId="formEmail">
						<ControlLabel>Email</ControlLabel>
						<FormControl name="email" type="email" placeholder="Email"/>
					</FormGroup>

					<FormGroup  controlId="formCPF">
						<ControlLabel>CPF</ControlLabel>
						<FormControl name="cpf" type="number" placeholder="CPF"/>
					</FormGroup>

					<FormGroup  controlId="formPhone">
						<ControlLabel>Telefone</ControlLabel>
						<FormControl name="phone" type="number" placeholder="Telefone"/>
					</FormGroup>

					<FormGroup  controlId="formPassword">
						<ControlLabel>Password</ControlLabel>
						<FormControl name="pass" type="password" placeholder="Password"/>
					</FormGroup>

					<FormGroup>
						<Button onClick={me.onSubmitSignupPF} block bsStyle="primary">
							Registrar
						</Button>
					</FormGroup>
				</Form>
			)
		} else {
			return (
				<Form id="formSignupPJ" onChange={me.onInputChange} key={me.state.timestamp}>
					<FormGroup  controlId="formName">
						<ControlLabel>Nome</ControlLabel>
						<FormControl name="name" type="text" placeholder="Nome"/>
					</FormGroup>

					<FormGroup  controlId="formEmail">
						<ControlLabel>Email</ControlLabel>
						<FormControl name="email" type="email" placeholder="Email"/>
					</FormGroup>

					<FormGroup  controlId="formCNPJ">
						<ControlLabel>CNPJ</ControlLabel>
						<FormControl name="cnpj" type="number" placeholder="CNPJ"/>
					</FormGroup>

					<FormGroup  controlId="formAddress">
						<ControlLabel>Endereço</ControlLabel>
						<FormControl name="address" type="text" placeholder="Endereço"/>
					</FormGroup>

					<FormGroup  controlId="formCity">
						<ControlLabel>Cidade</ControlLabel>
						<FormControl name="city" type="text" placeholder="Cidade"/>
					</FormGroup>

					<FormGroup  controlId="formState">
						<ControlLabel>Estado</ControlLabel>
						<FormControl name="state" type="text" placeholder="Estado"/>
					</FormGroup>

					<FormGroup  controlId="formNickname">
						<ControlLabel>Nome Fantasia</ControlLabel>
						<FormControl name="nickname" type="text" placeholder="Nome Fantasia"/>
					</FormGroup>

					<FormGroup  controlId="formPhone">
						<ControlLabel>Telefone</ControlLabel>
						<FormControl name="phone" type="number" placeholder="Telefone"/>
					</FormGroup>

					<FormGroup  controlId="formPassword">
						<ControlLabel>Password</ControlLabel>
						<FormControl name="pass" type="password" placeholder="Password"/>
					</FormGroup>

					<FormGroup  controlId="formPaymentDay">
						<ControlLabel>Dia de vencimento</ControlLabel>
						<br/>
						<Select 
							bsStyle='default' 
							bsSize='xsmall' 
							title={me.state.paymentDay}
							id={"paymentDaySelect"}
						>
							<Option
								eventKey={{paymentDay: 5}}
								onSelect={me.paymentDayUpdate}
							>
								{"5"}
							</Option>
							<Option
								eventKey={{paymentDay: 10}}
								onSelect={me.paymentDayUpdate}
							>
								{"10"}
							</Option>
							<Option
								eventKey={{paymentDay: 15}}
								onSelect={me.paymentDayUpdate}
							>
								{"15"}
							</Option>
							<Option
								eventKey={{paymentDay: 20}}
								onSelect={me.paymentDayUpdate}
							>
								{"20"}
							</Option>
							<Option
								eventKey={{paymentDay: 25}}
								onSelect={me.paymentDayUpdate}
							>
								{"25"}
							</Option>
						</Select>
					</FormGroup>

					<FormGroup  controlId="formDocumentFile">
						<ControlLabel>Foto do documento</ControlLabel>
						<Dropzone
					      multiple={false}
					      accept="image/jpg"
					      onDrop={(accepted, rejected) => { this.onImageDrop({ accepted, rejected }); }} >
					      	<a id="Ateste" style={{backgroundColor: this.dropzoneGetColor()}}>{this.dropzoneGetTitle()}</a>
					    </Dropzone>
				    </FormGroup>

					<FormGroup>
						<Button onClick={me.onSubmitSignupPJ} block bsStyle="primary">
							Registrar
						</Button>
					</FormGroup>
				</Form>
			)
		}
	},

	deliveryTypeUpdate: function(data) {
		this.setState({ deliveryType: data.deliveryType });
	},

	paymentDayUpdate: function(data) {
		this.setState({ paymentDay: data.paymentDay });
	},

	getTitleDeliveryType: function(status) {
		var label;

		switch(status) {
			case 0:
				label = 'Entrega normal';
				break;
			case 1:
				label = 'Cartório';
				break;
			case 2:
				label = 'Banco';
				break;
			case 3:
				label = 'Correio';
				break;
			default:
				label = 'Entrega com espera';
				break;
		}

		return label;
	},

	dropzoneGetColor: function() {
		if(this.state.documentFile == null) {
			return '#FFFFFF';
		} else {
			return '#9A9A9A';
		}
	},

	dropzoneGetTitle: function() {
		if(this.state.documentFile == null) {
			return "Arraste a imagem ou clique aqui para selecionar o arquivo.";
		} else {
			return "Imagem carregada.";
		}
	},

	onImageDrop(accepted, rejected) {
		if(accepted.rejected) {
			if(accepted.rejected[0]) {
				if(accepted.rejected[0].preview) {
					this.state.documentFile = accepted.rejected[0].preview;
				}
			}
		}
	},
	
	render: function() {
		var me = this;
		fetch('https://us-central1-ajato-29abc.cloudfunctions.net/business_day')
		.then(function(response) {
			return response.json();
		}).then(function(isOpen) {
			me.isOpen = isOpen;
		});

		return (
			<div style={style.container}>
				<div style={style.mapWrapper}>
					<div id="map"/>
				</div>

				<div className="orderbox" style={style.orderBox}>
					<Form onChange={me.onInputChange} className="initOrder activebox">
						<BadgeAddress 
							order={0}
							title="Origem"
						/>

						<FormGroup controlId="origin">
							<FormControl 
								className="autocomplete custom-input"
								type="text"
								name="origin"  
								placeholder="Rua, número"
							/>

							<FormControl 
								className="hidden"
								type="number"
								name="originNumber"  
								placeholder="Nº"
							/>

							<FormControl 
								className="custom-input"
								type="text"
								name="originComplement"
								placeholder="Complemento"
							/>

							<FormControl 
								className="custom-input"
								type="text"
								name="originWhatTodo"
								placeholder="O que fazer"
							/>
						</FormGroup>

						<RadioGroup
							icons={true} 
							style={style.packageType} 
							options={me.state.packageOptions}
							onChange={me.onChangePackage}
						/>

						<ControlLabel>Tipo de entrega</ControlLabel>
						<br/>
						<Select 
							bsStyle='default' 
							bsSize='xsmall' 
							title={me.getTitleDeliveryType(me.state.deliveryType)} 
							id={"deliveryTypeSelect"}
						>
							<Option
								eventKey={{deliveryType: 0}}
								onSelect={me.deliveryTypeUpdate}
							>
								{"Entrega normal"}
							</Option>
							<Option
								eventKey={{deliveryType: 1}}
								onSelect={me.deliveryTypeUpdate}
							>
								{"Cartório"}
							</Option>
							<Option
								eventKey={{deliveryType: 2}}
								onSelect={me.deliveryTypeUpdate}
							>
								{"Banco"}
							</Option>
							<Option
								eventKey={{deliveryType: 3}}
								onSelect={me.deliveryTypeUpdate}
							>
								{"Correio"}
							</Option>
							<Option
								eventKey={{deliveryType: 4}}
								onSelect={me.deliveryTypeUpdate}
							>
								{"Entrega com espera"}
							</Option>
						</Select>

						<Button onClick={me.next} 
								block 
								bsStyle="default"
								style={style.nextButton}>
							{"Avançar"}
						</Button>
					</Form>

					<Form onChange={me.onInputChange} className="closeOrder nextbox">
						<BadgeAddress 
							id="destination"
							order={1}
							title="Destino"
							address={me.state.destinationStreet}
							collapsed={me.state.open.destination}
						/>

						<Collapse in={me.state.open.destination}>
							<FormGroup controlId="destination">
								<FormControl 
									className="autocomplete custom-input"
									type="text"
									name="destination"  
									placeholder="Rua, número"
								/>

								<FormControl 
									className="hidden"
									type="number"
									name="destinationNumber"  
									placeholder="Nº"
								/>

								<FormControl 
									className="custom-input"
									type="text"
									name="destinationComplement"
									placeholder="Complemento"
								/>

								<FormControl 
									className="custom-input"
									type="text"
									name="destinationWhatTodo"
									placeholder="O que fazer"
								/>
							</FormGroup>
						</Collapse>

						<div style={me.state.open.waypoint01 || me.state.waypoint01 
									? style.showWaypointAddress : style.hideWaypointAddress}>
							<div style={style.divider} />

							<BadgeAddress 
								id="waypoint01"
								order={2}
								title="Destino"
								address={me.state.waypoint01Street}
								collapsed={me.state.open.waypoint01}
							/>

							<Collapse in={me.state.open.waypoint01}>
								<FormGroup controlId="waypoint01">
									<FormControl 
										className="autocomplete custom-input"
										type="text"
										name="waypoint01"  
										placeholder="Rua, número"
									/>

									<FormControl 
										className="hidden"
										type="number"
										name="waypoint01Number"  
										placeholder="Nº"
									/>

									<FormControl 
										className="custom-input"
										type="text"
										name="waypoint01Complement"
										placeholder="Complemento"
									/>

									<FormControl 
										className="custom-input"
										type="text"
										name="waypoint01WhatTodo"
										placeholder="O que fazer"
									/>
								</FormGroup>
							</Collapse>
						</div>

						<div style={me.state.open.waypoint02 || me.state.waypoint02 
									? style.showWaypointAddress : style.hideWaypointAddress}>
							<div style={style.divider} />

							<BadgeAddress 
								id="waypoint02"
								order={3}
								title="Destino"
								address={me.state.waypoint02Street}
								collapsed={me.state.open.waypoint02}
							/>

							<Collapse in={me.state.open.waypoint02}>
							
								<FormGroup controlId="waypoint02">
									<FormControl 
										className="autocomplete custom-input"
										type="text"
										name="waypoint02"  
										placeholder="Rua, número"
									/>

									<FormControl 
										className="hidden"
										type="number"
										name="waypoint02Number"  
										placeholder="Nº"
									/>

									<FormControl 
										className="custom-input"
										type="text"
										name="waypoint02Complement"
										placeholder="Complemento"
									/>

									<FormControl 
										className="custom-input"
										type="text"
										name="waypoint02WhatTodo"
										placeholder="O que fazer"
									/>
								</FormGroup>
							</Collapse>
						</div>

						<Button onClick={me.onToggleWaypoint}
								block 
								bsStyle="default"
								disabled={(me.state.origin && me.state.destination )
									  ? false 
									  : true}
								className="icon-plus-squared"
								style={style.nextButton}>
							{"Adicionar outro endereço"}
						</Button>

						<Button onClick={me.next} 
								block 
								bsStyle="default"
								disabled={me.state.origin && me.state.destination ? false : true}
								style={style.nextButton}>
							{"Concluir"}
						</Button>

						<Button onClick={me.back} 
								block 
								bsStyle="default"
								style={style.backButton}>
							{"Voltar"}
						</Button>

						<Modal show={me.state.showAlertModal} onHide={me.closeAlertModal}>
							<Modal.Header closeButton>
								<Modal.Title>{"Aviso!"}</Modal.Title>
							</Modal.Header>
							<Modal.Body>
								<div style={{textAlign: 'left', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column'}}>
									<div style={{height:'100px'}}></div>
									<div style={{display: 'flex', justifyContent: 'space-between'}}>
										<span>Pagamentos via transferência bancária ficam pendentes até o envio do comprovante via email. Envie o comprovante da transferência para: contato@ajatomotobys.com. Ou se preferir envie o comprovante pelo WHATSAPP (11) 9-98690810.</span>
									</div>
									<div style={{height:'50px'}}></div>
									<Button onClick={me.closeAlertModal}
											bsStyle="success"
											style={{margin: '5px 0px'}}>
											{"Ok, entendi!"}
									</Button>
									<div style={{height:'100px'}}></div>
								</div>
							</Modal.Body>
						</Modal>

						<Modal show={me.state.showModal} onHide={me.closeModal}>
							<Modal.Header closeButton>
								<Modal.Title>{"Entre com sua conta ajato"}</Modal.Title>
							</Modal.Header>
							<Modal.Body>
								<div style={{textAlign: 'left', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column'}}>
										<Form horizontal onChange={me.onInputChange} style={style.form}>
											<FormGroup  controlId="formEmail">
												<ControlLabel>{"Email"}</ControlLabel>
												<FormControl name="email" type="email" placeholder="Email"/>
											</FormGroup>

											<FormGroup  controlId="formPassword">
												<ControlLabel>{"Senha"}</ControlLabel>
												<FormControl name="pass" type="password" placeholder="Password"/>
											</FormGroup>

											<FormGroup>
												<Button
													style={style.addWaypoint}
													bsStyle="link" 
													onClick={me.forgotPass}>
													{"Esqueceu a senha?"}
												</Button>
											</FormGroup>

											<FormGroup>
												<Button type="submit" onClick={me.onSubmit} block style={style.nextButton}>
													{"Entrar"}
												</Button>
											</FormGroup>

											<FormGroup>
												<Button onClick={me.register} block style={style.nextButton}>
													{"Registrar"}
												</Button>
											</FormGroup>
										</Form>
								</div>
							</Modal.Body>
						</Modal>

						<Modal show={me.state.showSignupModal} onHide={me.closeSignupModal}>
							<Modal.Header closeButton>
								<Modal.Title>{"Não está no ajato? Inscreva-se!"}</Modal.Title>
							</Modal.Header>
							<Modal.Body>
								<div style={{textAlign: 'left', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column'}}>
									<div className="formWrapper">
										<Tabs activeKey={this.state.fgtype} onSelect={this.handleType} id="user-tabs">
											<Tab eventKey={0} title="Usuários">
												{me.getForm(0)}
											</Tab>
											<Tab eventKey={1} title="Empresas">
												{me.getForm(1)}
											</Tab>
										</Tabs>
									</div>
								</div>
							</Modal.Body>
						</Modal>
					</Form>

					<div className="payOrder nextbox">
						<PackageType type={me.getPackageType()} />

						<div style={style.divider} />

						{me.getAddresses()}

						<b>{"Distância"}</b>
						<div style={{display: 'flex', justifyContent: 'center', fontSize: 'x-large', color: '#03a6dc'}}>
							<span>{me.state.distance.text}</span>
						</div>

						<div style={style.divider}/>
						<b>{"Valor"}</b>

						<div style={{display: 'flex', justifyContent: 'center', fontSize: 'x-large', color: '#03a6dc'}}>
							<PriceFormatter data={me.state.orderValue} />
						</div>

						<div style={style.divider}/>

						<Toggle
							style={style.returnToOrigin} 
							label="Adicionar retorno" 
							checked={me.state.returnToOrigin} 
							onChange={me.onChangeReturnToOrigin} />

						<Button onClick={me.payOrder} 
								block 
								bsStyle="default"
								style={style.nextButton}>
							{"Pagar"}
						</Button>
						<Button onClick={me.back} 
								block 
								bsStyle="default"
								style={style.backButton}>
							{"Voltar"}
						</Button>

						<Modal show={me.state.showPaymentModal} onHide={me.closePaymentModal} onEnter={me.changeModal}>
							<Modal.Header closeButton>
								<Modal.Title>{"Pagamento"}</Modal.Title>
							</Modal.Header>
							<Modal.Body className="paymentbox">
								<div className="buttonsbox activepaybox"
									 style={{padding: '20px',
											display: 'flex', 
											justifyContent: 'center', 
											alignItems: 'center', 
											flexDirection: 'column'}}>

									{me.boletoButton()}

									{me.transferButton()}

									<Button onClick={me.payWithMP}
											block
											bsStyle="primary"
											style={{width: '50%', backgroundColor: '#748297', borderColor: '#748297', color: '#fff'}}>
											{"Cartão de crédito"}
									</Button>

									{/*<Button onClick={me.closePaymentWithMoney}
											block
											bsStyle="primary"
											style={{width: '50%', backgroundColor: '#336600', borderColor: '#336600', color: '#fff'}}>
											{"Dinheiro"}
									</Button>*/}
								</div>

								<div className="depositsbox nextpaybox"
									 style={{padding: '20px',
									 	display: 'flex',
										flexDirection: 'column',
										justifyContent: 'space-between'}}>
									<Well>
										<div style={{display: 'flex', justifyContent: 'space-between', margin: '10px 0px'}}>
											<div style={{display: 'flex', flexDirection: 'column'}}>
												<b>BANCO ITAU</b>

												<span>AG:0786</span>
												<span>CC:07509-3</span>
												<span>FAV: GABRIEL SABINO</span>
											</div>

											<div style={{display: 'flex', flexDirection: 'column'}}>
												<b>BANCO BRADESCO</b>
											
												<span>AG:2500</span>
												<span>CC: 8427-1</span>
												<span>FAV: GABRIEL SABINO</span>
											</div>
											
											<div style={{display: 'flex', flexDirection: 'column'}}>
												<b>BANCO CAIXA:</b>
											
												<span>AG:0245</span>
												<span>CC:00020245-3</span>
												<span>FAV: VALDECI SABINO</span>
											</div>
										</div>

										<div style={{display: 'flex', justifyContent: 'space-between'}}>
											<div style={{display: 'flex', flexDirection: 'column'}}>
												<b>BANCO SANTANDER</b>
											
												<span>AG: 0658</span>
												<span>CC:13008374-9</span>
												<span>FAV: FENIX TRANSPORTADORA E MUDANÇA</span>
											</div>

											<div style={{display: 'flex', flexDirection: 'column'}}>
												<b>BANCO DO BRASIL</b>
											
												<span>AG: 1810-4</span>
												<span>CC: 32.176-1</span>
												<span>FAV: FENIX TRANSPORTADORA E MUDANÇAS</span>
											</div>
										</div>
									</Well>

									<div style={{display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap'}}>
										<Button onClick={me.otherPayment}
											bsStyle="default"
											style={{margin: '5px 0px'}}>
											<span className=" icon-left-open" />
											{"Alterar pagamento"}
										</Button>
										<Button onClick={me.closePaymentWithDeposit}
											bsStyle="success"
											style={{margin: '5px 0px'}}>
											{"Confirmar pagamento"}
										</Button>
									</div>
								</div>
								<div className="apibox nextpaybox"
									style={{padding: '20px',
									 	display: 'flex',
										flexDirection: 'column',
										justifyContent: 'space-between'}}>

									<div style={{display: 'flex', alignItems: 'center'}}>

										<div style={{padding: '20px', display: 'flex', flexDirection: 'column'}}>
											<span style={{color: '#ccc'}}>{"Total"}</span>
											<PriceFormatter 
												data={me.state.orderValue} 
												style={{margin: '0px auto', fontSize: '44px'}}
											/>
										</div>

										<Form 
											onChange={me.onInputPaymentChange} 
											id="paymentform"
											style={{display: 'flex', flexDirection: 'column'}} >

												<div>
												<h5>{"Informações de pagamento"}</h5>

												<RadioGroup 
													style={{display: 'flex'}} 
													options={me.state.paymentTypes}
													onChange={me.onChangePaymentType}
												/>

												<FormGroup>
													<FormControl 
														bsSize="small"
														type="number"
														id="cardNumber" 
														data-checkout="cardNumber" 
														placeholder="Número do cartão"
													/>
												</FormGroup>

												<FormGroup style={{display: 'flex'}}>
													<FormControl 
														type="number"
														id="cardExpirationMonth" 
														data-checkout="cardExpirationMonth" 
														placeholder="Mês (xx)"
													/>

													<FormControl 
														type="number"
														id="cardExpirationYear"
														data-checkout="cardExpirationYear"
														placeholder="Ano (xxxx)"
													/>

													<FormControl 
														type="password"
														id="securityCode"
														data-checkout="securityCode"
														placeholder="CVV"
													/>
												</FormGroup>
											</div>

											<div>
												<h5>{"Informações do titular"}</h5>

												<FormGroup style={{display: 'flex'}}>
													<FormControl 
														type="text"
														id="cardholderName" 
														data-checkout="cardholderName" 
														placeholder="Nome"
													/>
													
													<FormControl 
														id="docType" 
														data-checkout="docType" 
														componentClass="select" 
														placeholder="select"
														style={{display: 'none'}}
													/>
													
													<FormControl 
														type="text"
														id="docNumber" 
														data-checkout="docNumber" 
														placeholder="CPF"
													/>
												</FormGroup>
											</div>										
										</Form>

									</div>

									<div style={this.props.settings.list.depositEnable 
													? {display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap'}
													: {display: 'flex', justifyContent: 'flex-end', flexWrap: 'wrap'}
											}>

										<Button onClick={me.payWithMP}
											bsStyle="default"
											style={this.props.settings.list.depositEnable 
													? {margin: '5px 0px'}
													: {margin: '5px 0px', display: 'none'}
											}>
											<span className=" icon-left-open" />
											{"Alterar pagamento"}
										</Button>

										<Button onClick={me.requestPaymentWithMP}
											bsStyle="success"
											style={{margin: '5px 0px'}}>
											{"Solicitar pagamento"}
										</Button>
									</div>
								</div>
								<div className="messagebox nextpaybox"
									 style={{padding: '20px',
											display: 'flex', 
											justifyContent: 'center', 
											alignItems: 'center', 
											flexDirection: 'column'}}>

									<span>{"Para que o entregador possa realizar o seu serviço, forneça os códigos de segurança para ele nas retiradas e entregas!"}</span>

									<img width="200px" height="200px" src="https://firebasestorage.googleapis.com/v0/b/ajato-e2d54.appspot.com/o/imagem.jpg?alt=media&token=c6c787e9-3cfb-4444-92d2-4e5edece41d8"/>

									<Button onClick={me.closePaymentModal}
											block
											bsStyle="primary"
											style={{width: '50%', backgroundColor: '#748297', borderColor: '#748297', color: '#fff'}}>
											{"Entendi"}
									</Button>
								</div>
							</Modal.Body>
						</Modal>
					</div>
				</div>
			</div>		
		);
	}

});

module.exports = Home;


// WEBPACK FOOTER //
// ./src/components/Client/Home.jsx